/* <summary>
date: 25-11-2022
Name: GM
description: Page Added to create Authentication reducer
<summary>*/
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoggedIn: false,
  urlBeforeLogin: "",
  userGUID: "",
  userData: null,
  userProfileImage: "",
};

const authSlice = createSlice({
  initialState,
  name: "auth",
  reducers: {
    Login(state) {
      state.isLoggedIn = true;
    },
    Logout(state) {
      state.isLoggedIn = false;
      state.userGUID = "";
    },
    SavePrevLocation(state, action) {
      state.urlBeforeLogin = action.payload;
    },
    SetLoggedInUserData(state, action) {
      state.userData = action.payload;
    },

    SetLoggedInUserProfileImage(state, action) {
      state.userData = {
        ...state.userData,
        userProfileImage: action.payload.userProfileImage,
      };
    },
    updateUsername(state, action) {
      state.userData = {
        ...state.userData,
        userName: action.payload,
      };
    },
  },
});

export const {
  Login,
  Logout,
  SavePrevLocation,
  SetSessionExpired,
  SetLoggedInUserData,
  SetLoggedInUserProfileImage,
  updateUsername,
} = authSlice.actions;

export default authSlice.reducer;
